import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VisualizarBoletoService {

  public arquivoBase64: string;
  constructor() { }
}
